<template>
  <div>
    <div class="ct1 main-block" v-for="(category, index) of categories" :key="index">
      <h3 class="title"><span v-text="category.name"></span></h3>
      <div class="clearfix"></div>
      
      <RwvProductListItem :products="getProducts(products, category)"/>
    </div>
  </div>
</template>

<script>
import RwvProductListItem from "@/components/ProductListItem";
export default {
  name: "RwvProCategory",
  components: {
    RwvProductListItem
  },
  props: {
    categories: Array,
    products: Array
  },
  methods: {
    getProducts(products, category) {
      if(!products || products.length == 0) return [];
      const data = products.filter(x=>x.categoryId == category.id);
      return data ? data : [];
    }
  }
};
</script>